module.exports = __webpack_public_path__ + "media/images/IconWink-0fa6a2f5.png";